import * as React from 'react';
import { Tooltip, TooltipProps } from '@mui/material';

interface BaseTooltipProps extends Omit<TooltipProps, 'children'> {
  children: React.ReactElement;
}

export function BaseTooltip({ children, ...otherProps }: BaseTooltipProps) {
  return <Tooltip {...otherProps}>{children}</Tooltip>;
}
